const constantType = {
  deliveryTypes: {
    1: "Home Delivery",
    2: "Express Delivery",
    3: "Take Away",
    4: "Standard Delivery"
  },
  payemntTypes: {
    1: "Cash On delivery",
    2: "Card On delivery",
    3: "Sudexo Payment",
    4: "Online Payment",
  },
  orderTypes: {
    1: "Web Order",
    2: "App Order",
    3: "IOS App",
    4: "Android App",
  },
  orderStatus: {
    1: "Pending",
    2: "Confirmed",
    3: "Admin Cancel",
    4: "packed",
    5: "Shipped",
    6: "delivered",
    7: "customer cancel",
    8: "customer refund",
    9: "deleted",
    10: "Refund approved",
    11: "Feedback",
  },
  orderButton: {
    1: "Confirm Order",
    2: "Pack Order",
    3: "Admin Cancel",
    4: "Ship Order",
    5: "Deliver Order",
  },
  orderButtonMessage: {
    1: "This action will confirm selected orders.",
    2: "This action will change selected orders as ready to pickup state.",
    3: "This action will change cancel all selected orders .",
    4: "This action will change selected orders as shipped state.",
    5: "This action will change selected orders as delivered state.",
  },
};

export default constantType;
